import { doRequest } from "utils/core";

const newAPI = {
  getNews: (params) => {
    const url = `api/news/index`;
    return doRequest("get", url, { params });
  },
  getInitNew: (params) => {
    const url = `api/news/init`;
    return doRequest("get", url, { params });
  },
  getNew: (params) => {
    const url = "api/news/detail";
    return doRequest("get", url, { params });
  },
};

export default newAPI;
